/**
 * Shared PWA / installed-app detection helpers.
 *
 * Extracted so both the install prompt and any other caller share a single
 * definition of "are we running as an installed app?". The manifest's
 * `start_url` carries `?source=pwa`, which is a secondary signal on launch.
 */

/** True when running as an installed PWA (home-screen launch, no browser chrome). */
export function isStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  const displayModeStandalone =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(display-mode: standalone)').matches;
  // iOS Safari exposes navigator.standalone when launched from the home screen.
  const iosStandalone =
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true;
  // Secondary signal: the manifest start_url appends ?source=pwa.
  const launchedFromManifest =
    typeof window.location !== 'undefined' &&
    new URLSearchParams(window.location.search).get('source') === 'pwa';
  return displayModeStandalone || iosStandalone || launchedFromManifest;
}
